import { IBlockUser } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { block_USER } from "../../routes";

const BlockUser = async (props: IBlockUser) => {
  const body = {
    description: props.description,
    userType: props.userType,
  };
  try {
    return (await customAxios.post(block_USER + "/" + props.userId, body)).data;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

export default BlockUser;
